import React, { type FC } from 'react'
import ReactJson from 'react-json-view'
import { t } from 'i18next'
import { isNil } from 'lodash'

import { type ApiCallAsJson } from '../../types'
import { ApiCall } from '../../../../hooks/useApiCall'

interface Props {
  apiCall: ApiCall
}

export const ApiCallDetailsTab: FC<Props> = ({ apiCall }) => {
  const formatJsonObject = (): ApiCallAsJson | Record<string, never> => {
    if (isNil(apiCall)) {
      return {}
    }

    const data: ApiCallAsJson = {
      request: {
        endpoint: apiCall.request.endpoint,
        method: apiCall.request.method,
        headers: {},
        body: ''
      },
      responses: [],
      id: apiCall.id,
      status: apiCall.status,
      title: apiCall.title
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const parseBodyToJson = (responseBody: string) => {
      try {
        return JSON.parse(responseBody)
      } catch (error) {
        console.warn('Error parsing API call body as JSON. Using raw string instead.')
        return responseBody
      }
    }

    if (apiCall?.request.method !== 'GET' && !isNil(apiCall.request.body)) {
      data.request.body = parseBodyToJson(apiCall.request.body)
    }

    apiCall.request.headers.forEach(header => {
      data.request.headers[header.key] = header.value
    })

    apiCall.responses.forEach(response => {
      data.responses.push({
        date: response.date,
        status: response.status,
        body: parseBodyToJson(response.body)
      })
    })

    return data
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="text-lg font-medium text-slate-600">{t('api_call_request_label')}</div>
      <div className="rounded-md bg-neutral-100 p-1">
        <ReactJson src={formatJsonObject()} />
      </div>
    </div>
  )
}

ApiCallDetailsTab.displayName = 'ApiCallDetailsTab'
